// @flow
export const APP_GROUPS_REQUEST: 'APP_GROUPS_REQUEST' = 'APP_GROUPS_REQUEST';
export const APP_GROUPS_SUCCESS: 'APP_GROUPS_SUCCESS' = 'APP_GROUPS_SUCCESS';
export const APP_GROUPS_FAILURE: 'APP_GROUPS_FAILURE' = 'APP_GROUPS_FAILURE';

export const APPS_REQUEST: 'APPS_REQUEST' = 'APPS_REQUEST';
export const APPS_SUCCESS: 'APPS_SUCCESS' = 'APPS_SUCCESS';
export const APPS_FAILURE: 'APPS_FAILURE' = 'APPS_FAILURE';

export const EVENT_MAPPINGS_REQUEST = 'EVENT_MAPPINGS_REQUEST';
export const EVENT_MAPPINGS_SUCCESS = 'EVENT_MAPPINGS_SUCCESS';
export const EVENT_MAPPINGS_FAILURE = 'EVENT_MAPPINGS_FAILURE';

export const ATTRIBUTES_MAPPINGS_REQUEST = 'ATTRIBUTE_MAPPINGS_REQUEST';
export const ATTRIBUTES_MAPPINGS_SUCCESS = 'ATTRIBUTE_MAPPINGS_SUCCESS';
export const ATTRIBUTES_MAPPINGS_FAILURE = 'ATTRIBUBTE_MAPPINGS_FAILURE';



// WEBPACK FOOTER //
// ./src/constants/RailsApiActionTypes.js